import React from 'react'

function PageNotFound() {
    return (
        <div className="container my-4">
            <p>Page not found</p>
        </div>
    )
}
export default PageNotFound